import { create } from 'zustand'
import { updateProfile } from '../api/auth'
import type { Language } from '../i18n/translate'
import { useAuthStore } from './auth'

const LANG_KEY = 'optimus.language'

function initialLanguage(): { language: Language; hasLocalChoice: boolean } {
    try {
        const stored = localStorage.getItem(LANG_KEY)
        if (stored === 'de' || stored === 'en')
            return { language: stored, hasLocalChoice: true }
    } catch {
        // localStorage nicht verfügbar — Default Sprache bleibt
    }
    return { language: 'de', hasLocalChoice: false }
}

interface UiState {
    language: Language
    /** true, sobald im Browser explizit umgeschaltet wurde (localStorage gesetzt). */
    hasLocalChoice: boolean
    setLanguage: (language: Language) => void
    adoptProfileLanguage: (language: Language) => void
}

export const useUiStore = create<UiState>()((set, get) => {
    const init = initialLanguage()
    return {
        language: init.language,
        hasLocalChoice: init.hasLocalChoice,

        // Umschalten: lokal persistieren und Profil best effort synchronisieren
        setLanguage: language => {
            try {
                localStorage.setItem(LANG_KEY, language)
            } catch {
                // Persistenz ist optional
            }
            set({ language, hasLocalChoice: true })
            if (useAuthStore.getState().status === 'authenticated') {
                updateProfile({ userLanguage: language })
                    .then(profile => useAuthStore.getState().setUser(profile))
                    .catch(() => undefined)
            }
        },

        // Profil-Sprache übernehmen, wenn nie lokal gewählt wurde
        adoptProfileLanguage: language => {
            if (get().hasLocalChoice || get().language === language) return
            set({ language })
        },
    }
})
